/* ==========================================================
   FORCE DATE AFTER CUT OFF
   Active until 11:00 AM PT on the date inputted in settings
========================================================== */

window.FORCED_SHIP_DATE_CONFIG = {
  enabled: true,
  date: "2026\/06\/26",
  cutoffHour: 11
};

(function () {
  if (typeof handleDate !== "function" || typeof handleClick !== "function") return;

  const CONFIG = window.FORCED_SHIP_DATE_CONFIG || {};
  if (!CONFIG.enabled) return;

  // normalize YYYY/MM/DD → MM/DD/YYYY
  const FORCED_DATE_STR = (function () {
    if (!CONFIG.date) return null;
    const [yyyy, mm, dd] = CONFIG.date.split("/");
    return `${mm}/${dd}/${yyyy}`;
  })();
  if (!FORCED_DATE_STR || !CONFIG.date.match(/^\d{4}\/\d{2}\/\d{2}$/)) return;

  /* ---------- cutoff: 11:00 AM Pacific on forced date ---------- */
  function isBeforeCutoffPST() {
    try {
      const now = new Date();

      const parts = new Intl.DateTimeFormat("en-US", {
        timeZone: "America/Los_Angeles",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
      }).formatToParts(now);

      const get = (t) => parts.find(p => p.type === t)?.value;

      const yyyyNow = get("year");
      const mmNow = get("month");
      const ddNow = get("day");
      const hhNow = get("hour");
      const miNow = get("minute");
      const ssNow = get("second");

      const nowPST = new Date(
        `${yyyyNow}-${mmNow}-${ddNow}T${hhNow}:${miNow}:${ssNow}`
      );

      const [forceMM, forceDD, forceYYYY] = FORCED_DATE_STR.split("/");
      const cutoffPST = new Date(
        `${forceYYYY}-${forceMM}-${forceDD}T${String(CONFIG.cutoffHour).padStart(2, "0")}:00:00`
      );

      return nowPST < cutoffPST;
    } catch (e) {
      return false;
    }
  }

  function isShippingSelected() {
    return (
      deliveryOptions &&
      deliveryOptions[deliverySelection] &&
      deliveryOptions[deliverySelection].type === "shipping"
    );
  }

  /* ---------- 1) CALENDAR: enable Forced Date only AFTER speed selected ---------- */
  const ORIGINAL_handleDate = handleDate;
  handleDate = function (date) {
    const result = ORIGINAL_handleDate(date);

    try {
      if (!isBeforeCutoffPST()) return result;
      if (!isShippingSelected()) return result;
      if (optionSelection === -1) return result;

      const d = new Date(date);
      d.setHours(0, 0, 0, 0);

      const mm = String(d.getMonth() + 1).padStart(2, "0");
      const dd = String(d.getDate()).padStart(2, "0");
      const yyyy = d.getFullYear();
      const dateString = `${mm}/${dd}/${yyyy}`;

      if (dateString === FORCED_DATE_STR) {
        return [1, "day inner-day", ""];
      }
    } catch (e) {}

    return result;
  };

  /* ---------- helpers: "really click" the Forced Date ---------- */
  function clickForcedDateInDatepicker(rootSelector) {
    const root = document.querySelector(rootSelector);
    if (!root) return false;

    // 1. Parse the forced date string (MM/DD/YYYY)
    const [mm, dd, yyyy] = FORCED_DATE_STR.split('/');
    
    // 2. Convert to jQuery UI format
    // data-year is the full year (e.g., "2025")
    // data-month is 0-indexed (e.g., January is "0", Feb is "1")
    const targetYear = yyyy;
    const targetMonth = parseInt(mm, 10) - 1; 
    const targetDay = parseInt(dd, 10).toString(); // Removes leading zero for text matching (e.g. "05" -> "5")

    // 3. Find the specific cell dynamically
    const selector = `td[data-year="${targetYear}"][data-month="${targetMonth}"] a`;
    
    const a = Array.from(
      root.querySelectorAll(selector)
    ).find(el => (el.textContent || "").trim() === targetDay);

    if (!a) return false;

    const cell = a.closest("td");
    // Ensure the cell isn't disabled (though logic above should enable it)
    if (!cell || cell.classList.contains("ui-state-disabled")) return false;

    a.click();
    return true;
  }

function forceSelectDateByClick() {
  if (!isBeforeCutoffPST()) return;
  if (!isShippingSelected()) return;
  if (optionSelection === -1) return;

  const [mm, dd, yyyy] = FORCED_DATE_STR.split("/");
  const forcedDate = new Date(Number(yyyy), Number(mm) - 1, Number(dd));

  dateSelection = FORCED_DATE_STR;
  hasDateBeenSelected = true;

  try {
    $(".date-picker").datepicker("setDate", forcedDate);
    $(".date-picker__mobile").datepicker("setDate", forcedDate);

    updateTimes();
    updateEstimatedDate();

    $(".date-picker").datepicker("refresh");
    $(".date-picker__mobile").datepicker("refresh");
  } catch (e) {}
}


  /* ---------- 2) Hook handleClick (start watcher + initial force) ---------- */
  const ORIGINAL_handleClick = handleClick;
  handleClick = function (element, index, type, options) {
    ORIGINAL_handleClick(element, index, type, options);

    try {
      if (!isBeforeCutoffPST()) return;
      if (!isShippingSelected()) return;

      // initial force after first speed select
      const waitForSpeed = function () {
        if (optionSelection !== -1) {
          forceSelectDateByClick();
        } else {
          setTimeout(waitForSpeed, 30);
        }
      };

      waitForSpeed();
    } catch (e) {}
  };
})();